<template>
  <amplify-sign-in header-text="Login" slot="sign-in" username-alias="email" :hide-sign-up="true"></amplify-sign-in>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
